import './App.scss';
import Navigation from './navigation';
import React, { useState, useEffect } from 'react';
import { RiFacebookFill, RiGoogleFill, RiInstagramFill, RiTwitterXFill } from 'react-icons/ri';
import { LuLink2 } from 'react-icons/lu';
import { FaEdit } from 'react-icons/fa';
import SideForm from './components/SideForm';
let gurudwaras = require('./gurudwaras.json');

const GoogleMapsDirections = ({ lat, lng, add }) => {
  const [currentLocation, setCurrentLocation] = useState(null);

  useEffect(() => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCurrentLocation(`${latitude},${longitude}`);
        },
        (error) => {
          console.error('Geolocation error:', error);
          alert('Unable to access location. Using default location.');
          setCurrentLocation('Current+Location'); // Fallback if location is denied
        }
      );
    } else {
      alert('Geolocation is not supported in this browser.');
      setCurrentLocation('Current+Location');
    }
  }, []);

  const googleMapsLink = currentLocation
    ? `https://www.google.com/maps/dir/?api=1&origin=${currentLocation}&destination=${lat},${lng}`
    : '#';

  return (
    <div>
      <a href={googleMapsLink} target="_blank" rel="noopener noreferrer">
        {add}
      </a>
    </div>
  );
};

function TableView() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedGurudwara, setSelectedGurudwara] = useState(null);

  const openDrawerWithHash = (p) => {
    setSelectedGurudwara(p);
    setDrawerOpen(true);
  };
  const closeDrawer = () => {
    setDrawerOpen(false);
  };
  return (
    <div className="App">
      <Navigation />
      <div className="Table-header">
        <table>
          <tbody>
            <tr>
              <th>Code </th>
              <th className="edit-th" >Edit</th>
              <th>Socials</th>
              <th>Name</th>
              <th>Directions </th>
              <th>State</th>
              <th>Country </th>
            </tr>
            {gurudwaras.map((g) => {
              return (
                <>
                  {g.states.map((state) => {
                    return state.gurudwaras.map((i) => {
                      return (
                        <tr key={i.id}>
                          <td>{i.id}</td>
                          <td className="edit-th"><FaEdit onClick={() => openDrawerWithHash(i)} /></td>
                          <td>
                            <span className="socials">
                              {i.info.website ? (
                                <a href={i.info.website} target="_blank" rel="noreferrer">
                                  <LuLink2 />
                                </a>
                              ) : (
                                <></>
                              )}
                            </span>
                            <span className="socials">
                              {i.info.social.facebook ? (
                                <a href={i.info.social.facebook} target="_blank" rel="noreferrer">
                                  {' '}
                                  <RiFacebookFill />{' '}
                                </a>
                              ) : (
                                <></>
                              )}
                            </span>
                            <span className="socials">
                              {i.info.social.instagram ? (
                                <a href={i.info.social.instagram} target="_blank" rel="noreferrer">
                                  {' '}
                                  <RiInstagramFill />{' '}
                                </a>
                              ) : (
                                <></>
                              )}
                            </span>
                            <span className="socials">
                              {i.info.social.twitter ? (
                                <a href={i.info.social.twitter} target="_blank" rel="noreferrer">
                                  {' '}
                                  <RiTwitterXFill />{' '}
                                </a>
                              ) : (
                                <></>
                              )}
                            </span>
                            <span className="socials">
                              {i.info.social.google ? (
                                <a href={i.info.social.google} target="_blank" rel="noreferrer">
                                  {' '}
                                  <RiGoogleFill />{' '}
                                </a>
                              ) : (
                                <></>
                              )}
                            </span>
                          </td>
                          <td>{i.name}</td>
                          <td>
                            <GoogleMapsDirections
                              lat={i.info.address.latitude}
                              lng={i.info.address.longitude}
                              add={`${i.info.address.street}, ${i.info.address.city} ${i.info.address.city} -
                              ${i.info.address.zipcode}`}
                            />
                          </td>
                          <td>{state.name}</td> <td> {g.name}</td>
                        </tr>
                      );
                    });
                  })}
                </>
              );
            })}
          </tbody>
        </table>
      </div>
      <SideForm
        title={"Edit Gurudwara"}
        isOpen={drawerOpen}
        toggleDrawer={closeDrawer}
        selectedData={selectedGurudwara}
        onSave={(updatedData) => console.log(updatedData)}
      />
    </div>
  );
}

export default TableView;
